export const MEMBERS_CONSTS = {
    SET_MEMBERS_DATA:"SET_MEMBERS_DATA",
    CREATE_MEMBER_ITEM:"CREATE_MEMBER_ITEM",
    UPDATE_MEMBER_ITEM: "UPDATE_MEMBER_ITEM",
    DELETE_MEMBER_ITEM: "DELETE_MEMBER_ITEM",
    UPDATE_MEMBERS_POSITIONS: "UPDATE_MEMBERS_POSITIONS",
};
